import { forwardRef } from 'react';
import { IconButton as MuiIconButton } from '@mui/material';

/**
 * Icon-only button. Thin wrapper over MUI IconButton; exists so the
 * rest of the codebase can stay free of direct @mui imports and so
 * we have a single place to add design-system behaviours (tokens,
 * focus ring, disabled state, etc.) later.
 *
 * Accepts all props MUI IconButton accepts. The ref is forwarded so
 * the button can be used as a tooltip / popover anchor.
 */
const IconButton = forwardRef((props, ref) => <MuiIconButton ref={ref} {...props} />);

IconButton.displayName = 'IconButton';

export default IconButton;
